import styles from "./doctorsSearchBox.module.scss";
import React, { useState, useRef } from 'react';
import {
  useSearchBox,
  UseSearchBoxProps
} from 'react-instantsearch';

export function DoctorsSearchBox(props: UseSearchBoxProps) {
  const { query, refine } = useSearchBox(props);
  const [inputValue, setInputValue] = useState(query);
  const inputRef = useRef<HTMLInputElement>(null);

  function setQuery(newQuery: string) {
    setInputValue(newQuery);

    refine(newQuery);
  }

  return (
      <form
        className={styles.searchform}
        action=""
        role="search"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (inputRef.current) {
            setQuery(inputRef.current.value);
            inputRef.current.blur();
          }
        }}
        onReset={(event) => {
          event.preventDefault();
          event.stopPropagation();

          setQuery('');

          if (inputRef.current) {
            inputRef.current.focus();
          }
        }}
      >
        <input
          className={styles.searchbox}        
          ref={inputRef}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder="חיפוש לפי תחום או שם רופא/ה"
          spellCheck={false}
          maxLength={512}
          type="search"
          defaultValue={inputValue}
          onChange={(event) => {
            setQuery(event.currentTarget.value);
          }}
        />
        {!query && <button type="submit" className={styles.searchBtn}></button>}
      </form>
  );
}